export const theme = {
    color: {
        silver: "#ccc",
        alto: "#ddd",
        gallery: "#eee",
        white: "#fff",
        teal: "#008080",
        forestGreen: "#29a329",
        crimson: "#db143c",
    },
    breakpoint: {
        mobileMax: 767,
    },
};